exports.SETTINGS = {
    
    FIXED_HEADER: false, 	
    BACK_TO_TOP: false,		
    USE_LOADIMAGES: true,	
    USE_LOADMASK: true,	
    SLIDER_CLASS: '.swiper-container', 
    BREAKPOINTS: {             
        small: 426,
        tablet: 769
    }
}; 